import React, { forwardRef, useRef } from 'react';
import { clsx } from 'clsx';

export const WorkflowsChevronIcon = ({ expanded = false }: { expanded?: boolean }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={clsx('shrink-0 transition-transform duration-200', expanded && 'rotate-180')}
  >
    <path
      d="M4 6L8 10L12 6"
      stroke="#05050D"
      strokeOpacity="0.5"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const WorkflowsEyeIcon = forwardRef(
  ({ onClick = () => {} }: { onClick?: () => void }, ref: React.ForwardedRef<HTMLDivElement>) => {
    const innerRef = useRef<HTMLDivElement>(null);
    const resolvedRef = (ref || innerRef) as React.RefObject<HTMLDivElement>;

    return (
      <div
        ref={resolvedRef}
        className={'cursor-pointer opacity-30 hover:opacity-100'}
        onClick={onClick}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M1 11C1 11 4.375 5 10 5C15.625 5 19 11 19 11C19 11 15.625 17 10 17C4.375 17 1 11 1 11ZM10 14.8182C11.0443 14.8182 12.0458 14.4159 12.7842 13.6999C13.5227 12.9838 13.9375 12.0126 13.9375 11C13.9375 9.98736 13.5227 9.01619 12.7842 8.30014C12.0458 7.58409 11.0443 7.18182 10 7.18182C8.95571 7.18182 7.95419 7.58409 7.21577 8.30014C6.47734 9.01619 6.0625 9.98736 6.0625 11C6.0625 12.0126 6.47734 12.9838 7.21577 13.6999C7.95419 14.4159 8.95571 14.8182 10 14.8182Z"
            stroke="#05050D"
            strokeWidth="1.6"
          />
        </svg>
      </div>
    );
  },
);

export const WorkflowsEditIcon = forwardRef(
  ({ onClick = () => {} }: { onClick?: () => void }, ref: React.ForwardedRef<HTMLDivElement>) => {
    const innerRef = useRef<HTMLDivElement>(null);
    const resolvedRef = (ref || innerRef) as React.RefObject<HTMLDivElement>;

    return (
      <div
        ref={resolvedRef}
        className={'cursor-pointer opacity-30 hover:opacity-100'}
        onClick={onClick}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M7.33301 2.66665H4.53301C3.4129 2.66665 2.85285 2.66665 2.42503 2.88464C2.0487 3.07639 1.74274 3.38235 1.55099 3.75867C1.33301 4.1865 1.33301 4.74655 1.33301 5.86665V11.4667C1.33301 12.5867 1.33301 13.1468 1.55099 13.5747C1.74274 13.9509 2.0487 14.2569 2.42503 14.4487C2.85285 14.6667 3.4129 14.6667 4.53301 14.6667H10.133C11.2531 14.6667 11.8131 14.6667 12.241 14.4487C12.6173 14.2569 12.9233 13.9509 13.115 13.5747C13.333 13.1468 13.333 12.5867 13.333 11.4667V8.66667M5.33299 10.6667H6.44935C6.77547 10.6667 6.93854 10.6667 7.09201 10.6298C7.22801 10.5971 7.35807 10.5433 7.47741 10.4702C7.61194 10.3877 7.72727 10.2724 7.95787 10.0418L14.333 3.66665C14.8853 3.11437 14.8853 2.21894 14.333 1.66665C13.7807 1.11437 12.8853 1.11437 12.333 1.66665L5.95783 8.0418C5.72723 8.2724 5.61193 8.38773 5.52947 8.52227C5.45637 8.6416 5.40249 8.7716 5.36983 8.90767C5.33299 9.06113 5.33299 9.2242 5.33299 9.55033V10.6667Z"
            stroke="#2F2F33"
            strokeWidth="1.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    );
  },
);

export const WorkflowsDeleteIcon = forwardRef(
  ({ onClick = () => {} }: { onClick?: () => void }, ref: React.ForwardedRef<HTMLDivElement>) => {
    const innerRef = useRef<HTMLDivElement>(null);
    const resolvedRef = (ref || innerRef) as React.RefObject<HTMLDivElement>;
    return (
      <div
        ref={resolvedRef}
        className={'cursor-pointer opacity-30 hover:opacity-100'}
        onClick={onClick}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M6 2H10M2 4H14M12.6667 4L12.1991 11.0129C12.129 12.065 12.0939 12.5911 11.8667 12.99C11.6666 13.3412 11.3648 13.6235 11.0011 13.7998C10.588 14 10.0607 14 9.0062 14H6.9938C5.93927 14 5.41202 14 4.99889 13.7998C4.63517 13.6235 4.33339 13.3412 4.13332 12.99C3.90607 12.5911 3.871 12.065 3.80086 11.0129L3.33333 4M6.66667 7V10.3333M9.33333 7V10.3333"
            stroke="#2F2F33"
            strokeWidth="1.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    );
  },
);

export const WorkflowsDragIndicatorIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="none">
    <circle cx="1.66667" cy="1.33317" r="1.16667" fill="#05050D" fillOpacity="0.3" />
    <circle cx="1.66667" cy="6.00016" r="1.16667" fill="#05050D" fillOpacity="0.3" />
    <circle cx="1.66667" cy="10.6667" r="1.16667" fill="#05050D" fillOpacity="0.3" />
    <circle cx="6.33366" cy="1.33317" r="1.16667" fill="#05050D" fillOpacity="0.3" />
    <circle cx="6.33366" cy="6.00016" r="1.16667" fill="#05050D" fillOpacity="0.3" />
    <circle cx="6.33366" cy="10.6667" r="1.16667" fill="#05050D" fillOpacity="0.3" />
  </svg>
);
